<template>
    <div>
        <h1>Disconnecting...</h1>
    </div>
</template>

<script>

export default {
    created() {
        this.$store.dispatch("signout").then(() => {
            this.$router.push({ name: "home" });
        });
    }
};
</script>